import styled from 'styled-components'

export const NoMatchesFoundContainer = styled.div`
  text-align: center;
  padding: 142px;
  font-size: 18px;
  line-height: 32px;
  color: rgba(32, 32, 32, 0.5);
`

export const ClearFiltersLink = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
  text-decoration: underline;
  cursor: pointer;
`

export const StyledTable = styled.div`
  table {
    margin-bottom: 0;
    border: 1px solid rgba(233, 233, 233, 1);
    border-radius: 4px;
    th {
      box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
      border: 1px solid rgba(233, 233, 233, 1);      
      :last-child {
        text-align: right;
               
      }
    }    
  }
`

export const StyledDiv = styled.div`
  height: ${(p) => {
    return p.height ? p.height : 'auto'
  }};
  max-height: ${(p) => {
    // When overflow is off (e.g. All assessments modal), do not cap height or scrollbars appear.
    if (!p.overflow) return 'none'
    return p.height ? p.height : '630px'
  }};
  overflow: ${(p) => {
    return p.overflow ? 'auto' : 'visible'
  }};
`
